
import { ETaskStatus, ITask } from '../../../data_models/task'
import { EProjectStatus, IProject } from '../../../data_models/project'
import { IFreelancer } from '../../../data_models/freelancer'
import { FilledButton, FlatButton, OutlinedButton, TextButton } from '../../common/Button';
import { MdDragHandle } from 'react-icons/md';
import { useEffect, useState } from 'react';
import useTasks from '../../../hooks/useTasks';
import RichTextEditor from '../../common/RichTextEditor';
import { IoMdCheckmark, IoMdClose } from 'react-icons/io';
import RichText from '../../common/RichText';
import IconButton from '../../common/IconButton';
import { IoAdd, IoBuildOutline, IoCheckmark, IoChevronDown, IoChevronUp, IoPencil, IoSearchOutline, IoTrailSignOutline, IoTrashOutline } from 'react-icons/io5';
import { TaskStatusBatch } from '../../common/StatusBatch';
import { TbCalendarCheck, TbCalendarDue } from 'react-icons/tb';
import { PiUserGear } from 'react-icons/pi';
import { dateToShortReadable } from '../../../utils/dateUtils';
import MultiTextSelect from '../../common/MultiTextSelect';
import { Chip } from '../../common/Chip';
import EditTaskHeaderLightbox from '../../lightboxes/projects/EditTaskHeaderLightbox';
import CreateNewTaskLightbox from '../../lightboxes/projects/CreateNewTaskLightbox';
import useArielle from '../../../hooks/useArielle';
import AISuggestion from '../../common/AISuggestion';
import Tooltip from '../../common/Tooltip';
import { FiUserCheck } from 'react-icons/fi';
import ShortlistedFreelancersLightbox from '../../lightboxes/projects/ShortlistedFreelancersLightbox';
import useRouting from '../../../hooks/useRouting';
import StartAndPayTaskLightbox from '../../lightboxes/projects/StartAndPayTaskLightbox';
import { DEFAULT_USER_PROFILE } from '../../../config/defaultAssetUrls';
import { getFreelancerName } from '../../../utils/freelancerUtils';
import { EUserType } from '../../../data_models/enums';
import UnassignFreelancerLightbox from '../../lightboxes/projects/UnassignFreelancerLightbox';
import CompleteTaskLightbox from '../../lightboxes/projects/CompleteTaskLightbox';
import useCurrentUser from '../../../hooks/useCurrentUser';
import UnassignMyselfLightbox from '../../lightboxes/projects/UnassignMyselfLightbox';
import ProvideDeliveryLightbox from '../../lightboxes/projects/ProvideDeliveryLightbox';
import AcceptTaskDeliveryLightbox from '../../lightboxes/projects/AcceptTaskDeliveryLightbox';
import RequestTaskRevisionLightbox from '../../lightboxes/projects/RequestTaskRevisionLightbox';
import RequestTaskCompletion from '../../lightboxes/projects/RequestTaskCompletion';
import CreateNewRoadmapLightbox from '../../lightboxes/projects/CreateNewRoadmapLightbox';
import { EArielleProcessingType } from '../../../data_models/aiModels/enums';
import { ConfirmDeleteTaskLightbox } from '../../lightboxes/projects/ConfirmDeleteTaskLightbox';

export const ProjectDetailsRoadmap: React.FC<{
    project: IProject,
    tasks: ITask[],
    projectManager: IFreelancer | null,
    team: IFreelancer[],
    isPm: boolean,
    isRoadmapVerificationPm: boolean,
    isEmployer: boolean,
    isFreelancer: boolean,
    isOutsideFreelancer: boolean,
    isOutsideEmployer: boolean,

    setProject: (project: IProject) => void,
    setTasks: (tasks: ITask[]) => void,
    onAddTask: (task: ITask) => void,
    onUpdateTask: (task: ITask) => void,
    onUpdateProject: (project: IProject) => void,

}> = ({ project, tasks, projectManager, team, isPm, isRoadmapVerificationPm, isEmployer, isFreelancer, isOutsideFreelancer, isOutsideEmployer, setProject, setTasks, onAddTask, onUpdateTask, onUpdateProject }) => {

    const [canEdit, setCanEdit] = useState(false);
    const [canAddOrDeleteTasks, setCanAddOrDeleteTasks] = useState(false);
    const [canAddAdditionalTask, setCanAddAdditionalTask] = useState(false);
    const [canShortlistTalent, setCanShortlistTalent] = useState(false);
    const [canFindTalent, setCanFindTalent] = useState(false);
    const [canPayAndStart, setCanPayAndStart] = useState<string[]>([]); // task ids
    const [canDeleteTasks, setCanDeleteTasks] = useState<string[]>([]); // task ids
    const [canUnassignFreelancer, setCanUnassignFreelancer] = useState<string[]>([]); // task ids
    const [canUnassignMyself, setCanUnassignMyself] = useState<string[]>([]); // task ids
    const [canCompleteTask, setCanCompleteTask] = useState<string[]>([]); // task ids
    const [canProvideDelivery, setCanProvideDelivery] = useState<string[]>([]); // task ids
    const [canAcceptDelivery, setCanAcceptDelivery] = useState<string[]>([]); // task ids
    const [canRequestCompletion, setCanRequestCompletion] = useState<string[]>([]); // task ids
    const [canRequestRevision, setCanRequestRevision] = useState<string[]>([]); // task ids


    const [orderedTasks, setOrderedTasks] = useState<ITask[]>(tasks);

    const [editTaskHeader, setEditTaskHeader] = useState<string | null>(null);
    const [editDescription, setEditDescription] = useState<string | null>(null);
    const [editDefinitionOfDone, setEditDefinitionOfDone] = useState<string | null>(null);
    const [editSkills, setEditSkills] = useState<string | null>(null);
    const [editTools, setEditTools] = useState<string | null>(null);

    const [newDescription, setNewDescription] = useState<string | null>(null);
    const [newDefinitionOfDone, setNewDefinitionOfDone] = useState<string | null>(null);
    const [newSkills, setNewSkills] = useState<string[] | null>(null);
    const [newTools, setNewTools] = useState<string[] | null>(null);

    const [isSavingDescription, setIsSavingDescription] = useState(false);
    const [isSavingDefinitionOfDone, setIsSavingDefinitionOfDone] = useState(false);
    const [isSavingSkills, setIsSavingSkills] = useState(false);
    const [isSavingTools, setIsSavingTools] = useState(false);

    const [suggestedDescription, setSuggestedDescription] = useState<string | null>(null);
    const [suggestedDefinitionOfDone, setSuggestedDefinitionOfDone] = useState<string | null>(null);


    const [showTaskDetails, setShowTaskDetails] = useState<string[]>([]);

    const [showCreateNewRoadmapLightbox, setShowCreateNewRoadmapLightbox] = useState(false);
    const [showEditTaskHeader, setShowEditTaskHeader] = useState(false);
    const [showCreateNewTask, setShowCreateNewTask] = useState(false);
    const [showDeleteTaskLightbox, setShowDeleteTaskLightbox] = useState<string | null>(null);
    const [showShortlistedFreelancersLightbox, setShowShortlistedFreelancersLightbox] = useState<string | null>(null);
    const [showPayAndStartLightbox, setShowPayAndStartLightbox] = useState<string | null>(null);
    const [showUnassignFreelancerLightbox, setShowUnassignFreelancerLightbox] = useState<string | null>(null);
    const [showUnassignMyselfLightbox, setShowUnassignMyselfLightbox] = useState<string | null>(null);
    const [showCompleteTaskLightbox, setShowCompleteTaskLightbox] = useState<string | null>(null);
    const [showProvideDeliveryLightbox, setShowProvideDeliveryLightbox] = useState<string | null>(null);
    const [showAcceptDeliveryLightbox, setShowAcceptDeliveryLightbox] = useState<string | null>(null);
    const [showRequestCompletionLightbox, setShowRequestCompletionLightbox] = useState<string | null>(null);
    const [showRequestRevisionLightbox, setShowRequestRevisionLightbox] = useState<string | null>(null);

    const { goToBrowseFreelancers, goToUserProfile } = useRouting();
    const { currentUser } = useCurrentUser();
    const {
        pushRank,
        updateTask,
    } = useTasks();
    const {
        requestTaskDescription,
        requestTaskDefinitionOfDone,
        lastReceivedTaskDescription,
        lastReceivedTaskDefinitionOfDone,
        isProcessing,
        setLastRequestedTaskDescriptionTimestamp,
        setLastRequestedTaskDefinitionOfDoneTimestamp
    } = useArielle();


    const onCreateRoadmap = () => {
        setShowCreateNewRoadmapLightbox(true);
    }
    useEffect(() => {

        // can edit
        if ((isPm || isEmployer || isRoadmapVerificationPm) &&
            (project.status || 0) < EProjectStatus.IN_PROGRESS) {
            setCanEdit(true);
        }


        // can add task (regular)
        if ((isPm || isEmployer || isRoadmapVerificationPm) &&
            (project.status || 0) < EProjectStatus.IN_PROGRESS) {
            setCanAddOrDeleteTasks(true);
        }

        // can add additional task (additional)
        if ((isPm || isEmployer || isRoadmapVerificationPm
        ) &&
            (project.status || 0) === EProjectStatus.IN_PROGRESS) {
            setCanAddAdditionalTask(true);
        }

        // can shortlist talent
        if (isEmployer || isPm || isRoadmapVerificationPm) {
            setCanShortlistTalent(true);
        }

        // can find talent
        if ((isEmployer || isPm) &&
            (project.status || 0) <= EProjectStatus.IN_PROGRESS) {
            setCanFindTalent(true);
        }

        // can pay and start
        if (isEmployer) {
            const newTaskIds = tasks.filter(task => task.currentStatus === ETaskStatus.WAIT_FOR_PAYMENT).map(task => task._id!);
            setCanPayAndStart(newTaskIds);
        }

        // can delete tasks 
        if (isEmployer && (project.status === EProjectStatus.DRAFT)) {
            const deleteTaskIds = tasks.filter(task => (task.currentStatus || Infinity) < ETaskStatus.WAIT_FOR_PAYMENT).map(task => task._id!);
            setCanDeleteTasks(deleteTaskIds);
        } else {
            setCanDeleteTasks([]);
        }


        // can unassign freelancer
        if (isPm || (isEmployer && project.ownerManaged)) {
            const newTaskIds = tasks.filter(task =>
                (task.currentStatus || 0) >= ETaskStatus.IN_PROGRESS &&
                (task.currentStatus || Infinity) < ETaskStatus.COMPLETED &&
                (task.currentStatus || Infinity) !== ETaskStatus.DELIVERY_PROVIDED &&
                task.currentlyAssignedTo).map(task => task._id!);
            setCanUnassignFreelancer(newTaskIds);
        }
        // can unassignMyself
        if (isFreelancer) {
            const newTaskIds = tasks.filter(task =>
                (task.currentStatus || 0) >= ETaskStatus.IN_PROGRESS &&
                (task.currentStatus || Infinity) < ETaskStatus.COMPLETED &&
                task.currentlyAssignedTo === currentUser?._id).map(task => task._id!);
            setCanUnassignMyself(newTaskIds);
        }

        // can complete task
        if (isEmployer) {
            const newTaskIds = tasks.filter(task =>
                (task.currentStatus || 0) >= ETaskStatus.IN_PROGRESS &&
                (task.currentStatus || Infinity) < ETaskStatus.COMPLETED &&
                (task.currentStatus || Infinity) !== ETaskStatus.DELIVERY_PROVIDED &&
                (task.currentStatus || Infinity) !== ETaskStatus.IN_REVISION_DELIVERY_PROVIDED &&
                task.currentlyAssignedTo).map(task => task._id!);
            setCanCompleteTask(newTaskIds);
        }

        // can provide delivery
        if (isFreelancer) {
            const newTaskIds = tasks.filter(task =>
                ((task.currentStatus || 0) === ETaskStatus.IN_PROGRESS ||
                    (task.currentStatus || 0) === ETaskStatus.IN_REVISION) &&
                task.currentlyAssignedTo === currentUser?._id).map(task => task._id!);
            setCanProvideDelivery(newTaskIds);
        }

        // can accept delivery
        if (isEmployer) {
            const newTaskIds = tasks.filter(task =>
                (task.currentStatus || 0) === ETaskStatus.DELIVERY_PROVIDED ||
                (task.currentStatus || 0) === ETaskStatus.IN_REVISION_DELIVERY_PROVIDED).map(task => task._id!);
            setCanAcceptDelivery(newTaskIds);
        }

        // can request completion
        if (isPm) {
            const newTaskIds = tasks.filter(task =>
                (task.currentStatus || 0) === ETaskStatus.IN_PROGRESS ||
                (task.currentStatus || 0) === ETaskStatus.DELIVERY_PROVIDED ||
                (task.currentStatus || 0) === ETaskStatus.IN_REVISION ||
                (task.currentStatus || 0) === ETaskStatus.IN_REVISION_DELIVERY_PROVIDED).map(task => task._id!);
            setCanRequestCompletion(newTaskIds);
        }

        // can request revision
        if (isEmployer || isPm) {
            const newTaskIds = tasks.filter(task =>
                (task.currentStatus || 0) === ETaskStatus.DELIVERY_PROVIDED ||
                (task.currentStatus || 0) === ETaskStatus.IN_REVISION_DELIVERY_PROVIDED ||
                (task.currentStatus || 0) === ETaskStatus.REQUESTED_COMPLETION).map(task => task._id!);
            setCanRequestRevision(newTaskIds);
        }




    }, [project, tasks, isPm, isRoadmapVerificationPm, isEmployer]);

    useEffect(() => {

        if (editDescription) {
            setNewDescription(tasks.find(task => task._id === editDescription)?.description || null);
        } else {
            setNewDescription(null);
        }
        if (editDefinitionOfDone) {
            setNewDefinitionOfDone(tasks.find(task => task._id === editDefinitionOfDone)?.definitionOfDone || null);
        } else {
            setNewDefinitionOfDone(null);
        }
        if (editSkills) {
            setNewSkills(tasks.find(task => task._id === editSkills)?.requiredSkills || []);
        } else {
            setNewSkills(null);
        }
        if (editTools) {
            setNewTools(tasks.find(task => task._id === editTools)?.requiredTools || []);
        } else {
            setNewTools(null);
        }

    }, [editDescription,
        editDefinitionOfDone,
        editSkills,
        editTools]);


    useEffect(() => {

        if (newDescription && editDescription) {
            requestTaskDescription(editDescription, { description: newDescription || '' });
        }
        if (newDefinitionOfDone && editDefinitionOfDone) {
            requestTaskDefinitionOfDone(editDefinitionOfDone, { definitionOfDone: newDefinitionOfDone || '' });
        }
    }, [newDescription,
        newDefinitionOfDone,
    ]);



    useEffect(() => {
        setOrderedTasks(tasks.sort((a, b) => a.projectRank! - b.projectRank!));
    }, [tasks]);


    useEffect(() => {
        if (lastReceivedTaskDescription) {
            setSuggestedDescription(lastReceivedTaskDescription.description);
        }
    }, [lastReceivedTaskDescription]);

    useEffect(() => {
        if (lastReceivedTaskDefinitionOfDone) {
            setSuggestedDefinitionOfDone(lastReceivedTaskDefinitionOfDone.definitionOfDone);
        }
    }, [lastReceivedTaskDefinitionOfDone]);


    const handleDragStart = (e: React.DragEvent<HTMLDivElement>, index: number) => {
        e.dataTransfer.setData('text/plain', index.toString());
        e.currentTarget.classList.add('opacity-50', 'scale-105', 'transition-all', 'duration-200');
    };

    const handleDragOver = (e: React.DragEvent<HTMLDivElement>) => {
        e.preventDefault();
        e.currentTarget.classList.add('bg-neutral-50', 'scale-105', 'transition-all', 'duration-200');
    };

    const handleDragLeave = (e: React.DragEvent<HTMLDivElement>) => {
        e.currentTarget.classList.remove('bg-neutral-50', 'scale-105', 'transition-all', 'duration-200');
    };

    const handleDrop = async (e: React.DragEvent<HTMLDivElement>, targetIndex: number) => {
        e.preventDefault();
        e.currentTarget.classList.remove('bg-neutral-50', 'scale-105', 'transition-all', 'duration-200');

        const sourceIndex = parseInt(e.dataTransfer.getData('text/plain'));
        if (sourceIndex !== targetIndex) {
            const newTasks = Array.from(orderedTasks);
            const [removed] = newTasks.splice(sourceIndex, 1);
            newTasks.splice(targetIndex, 0, removed);
            setOrderedTasks(newTasks);

            const result = await pushRank(removed._id!, targetIndex + 1);
            setTasks(result.allTasks);
        }
    };

    const onSaveDescription = async () => {
        // doublecheck if there is a task id for the new description
        const task = tasks.find(task => task._id === editDescription);
        if (!editDescription || !task) {
            setEditDescription(null);
            return;
        }

        setIsSavingDescription(true);
        if (newDescription !== null) {
            const updateObject: ITask = {
                ...task,
                description: newDescription,
            }
            const updatedTask = await updateTask(task._id!, updateObject);
            onUpdateTask(updatedTask);
            setEditDescription(null);
        }
        setIsSavingDescription(false);
    };

    const onSaveDefinitionOfDone = async () => {
        // doublecheck if there is a task id for the new definition of done
        const task = tasks.find(task => task._id === editDefinitionOfDone);
        if (!editDefinitionOfDone || !task) {
            setEditDefinitionOfDone(null);
            return;
        }

        setIsSavingDefinitionOfDone(true);
        if (newDefinitionOfDone !== null) {
            const updateObject: ITask = {
                ...task,
                definitionOfDone: newDefinitionOfDone,
            }
            const updatedTask = await updateTask(task._id!, updateObject);
            onUpdateTask(updatedTask);
            setEditDefinitionOfDone(null);
        }
        setIsSavingDefinitionOfDone(false);
    };

    const onSaveSkills = async () => {
        // doublecheck if there is a task id for the new skills
        const task = tasks.find(task => task._id === editSkills);
        if (!editSkills || !task) {
            setEditSkills(null);
            return;
        }

        setIsSavingSkills(true);
        if (newSkills !== null) {
            const updateObject: ITask = {
                ...task,
                requiredSkills: newSkills,
            }
            const updatedTask = await updateTask(task._id!, updateObject);
            onUpdateTask(updatedTask);
            setEditSkills(null);
        }
        setIsSavingSkills(false);
    };

    const onSaveTools = async () => {
        // doublecheck if there is a task id for the new tools
        const task = tasks.find(task => task._id === editTools);
        if (!editTools || !task) {
            setEditTools(null);
            return;
        }

        setIsSavingTools(true);
        if (newTools !== null) {
            const updateObject: ITask = {
                ...task,
                requiredTools: newTools,
            }
            const updatedTask = await updateTask(task._id!, updateObject);
            onUpdateTask(updatedTask);
            setEditTools(null);
        }
        setIsSavingTools(false);
    };

    const onEditTaskHeader = (task: ITask) => {
        if (!task) {
            return;
        }
        setEditTaskHeader(task._id!);
        setShowEditTaskHeader(true);
    }

    const onDeleteTask = (taskId: string) => {
        setShowDeleteTaskLightbox(taskId);
    }

    const onPayAndStart = (taskId: string) => {
        setShowPayAndStartLightbox(taskId);
    }

    const onUnassignFreelancer = (taskId: string) => {
        setShowUnassignFreelancerLightbox(taskId);
    }

    const onUnassignMyself = (taskId: string) => {
        setShowUnassignMyselfLightbox(taskId);
    }

    const onCompleteTask = (taskId: string) => {
        setShowCompleteTaskLightbox(taskId);
    }

    const onProvideDelivery = (taskId: string) => {
        setShowProvideDeliveryLightbox(taskId);
    }

    const onAcceptDelivery = (taskId: string) => {
        setShowAcceptDeliveryLightbox(taskId);
    }

    const onRequestCompletion = (taskId: string) => {
        setShowRequestCompletionLightbox(taskId);
    }

    const onRequestRevision = (taskId: string) => {
        setShowRequestRevisionLightbox(taskId);
    }

    return (
        <div className="flex flex-col gap-4">

            <div className="-mt-2 -ml-4 flex flex-wrap items-center justify-between sm:flex-nowrap">
                <div className="mt-2 ml-4">
                    <h3 className="text-2xl font-semibold text-gray-900">Roadmap</h3>
                </div>
                <div className="mt-2 ml-4 shrink-0 space-x-2">
                    {canAddOrDeleteTasks &&
                        <Tooltip text="Manually create a new task.">
                            <OutlinedButton
                                onClick={() => { setShowCreateNewTask(true) }}
                                theme='primary'
                                icon={<IoAdd />}
                            >Create Task
                            </OutlinedButton>
                        </Tooltip>}

                    {canFindTalent &&
                        <Tooltip text="Find talent for your tasks.">
                            <OutlinedButton
                                onClick={() => { goToBrowseFreelancers() }}
                                theme='primary'
                                icon={<IoSearchOutline />}
                            >Find Talent
                            </OutlinedButton>
                        </Tooltip>}

                    {/* {canAddAdditionalTask && <FlatButton
                        onClick={() => { }}
                        theme='primary'
                        icon={<IoAdd />}
                    >Add Additional Task
                    </FlatButton>} */}
                </div>
            </div>
            <div className="p-4 overflow-hidden rounded-lg bg-white shadow-lg border border-gray-200">
                {/* <div className=" bg-white px-4 py-5 sm:px-6">
                </div> */}


                {/* Task List */}
                {tasks.length === 0 ? <div className="flex flex-col items-center space-y-4 ">
                    <img
                        src="https://storage.googleapis.com/public-platform-assets/images/no_data.svg"
                        alt="No Data"
                        className="w-2/3 mx-auto"
                    />
                    <p className="w-full text-center mt-4 text-gray-600">At this moment, there are no tasks for this project.</p>
                    <Tooltip text={project._roadmapVerifiedAt
                        ? 'This button is disabled because your current roadmap is already verified. Starting fresh would replace the verified version.'
                        : (project._waitingForRoadmapVerification && !project.currentRoadmapVerificationPm)
                            ? 'Your roadmap is under review. Creating a new one would disturb the process.'
                            : 'Arielle, our AI assistant producer, will build a new roadmap in no time for you!'}>
                        <FilledButton
                            onClick={onCreateRoadmap}
                            icon={<IoTrailSignOutline />}
                            isLoading={isProcessing.has(EArielleProcessingType.CREATE_PROJECT_ROADMAP)}
                            theme='primary'
                            disabled={!!project._roadmapVerifiedAt || (project._waitingForRoadmapVerification && !project.currentRoadmapVerificationPm)}
                        >Build New Roadmap</FilledButton>
                    </Tooltip>
                </div> :
                    <div className='flex flex-col gap-4'>
                        {orderedTasks.map((task, index) => (
                            <div key={task._id}>
                                <div
                                    draggable
                                    onDragStart={(e) => handleDragStart(e, index)}
                                    onDragOver={handleDragOver}
                                    onDragLeave={handleDragLeave}
                                    onDrop={(e) => handleDrop(e, index)}
                                    onDragEnd={(e) => {
                                        e.currentTarget.classList.remove('opacity-50', 'scale-105', 'transition-all', 'duration-200');
                                    }}
                                    className={`transition-all duration-300 rounded-lg border p-4 hover:border-primary hover:shadow-lg
                                    ${isFreelancer && task.currentlyAssignedTo === currentUser?._id ? 'border-secondary-500 shadow-md' : 'border-gray-200'}`}
                                >

                                    {/* Task Header */}
                                    <div className='flex flex-col'>
                                        {/* Title */}
                                        <div className='flex flex-row items-center justify-between'>
                                            <div className='flex flex-row items-center gap-2'>
                                                {canEdit && <MdDragHandle size={14} className='cursor-move text-primary' />}
                                                <p className='font-bold text-md'>{task.projectRank}. {task.title}</p>
                                                <TaskStatusBatch status={task.currentStatus} variant='flat' />
                                                {canEdit && <IconButton
                                                    icon={<IoPencil />}
                                                    onClick={() => onEditTaskHeader(task)}
                                                    theme='primary'
                                                    disabled={project._roadmapVerifiedBy !== undefined && project._roadmapVerifiedBy !== null}
                                                />}
                                            </div>

                                            <div className='flex flex-row gap-2'>
                                                {canPayAndStart.includes(task._id!) &&
                                                    <FilledButton
                                                        onClick={() => { onPayAndStart(task._id!) }}
                                                        theme='primary'
                                                        icon={<IoCheckmark />}
                                                        size='small'
                                                    >Pay and Start
                                                    </FilledButton>
                                                }

                                                {canDeleteTasks.includes(task._id!) &&
                                                    <FilledButton
                                                        onClick={() => { onDeleteTask(task._id!) }}
                                                        theme='danger'
                                                        icon={<IoTrashOutline />}
                                                        size='small'
                                                        disabled={project._roadmapVerifiedBy !== undefined && project._roadmapVerifiedBy !== null}
                                                    >Delete Task
                                                    </FilledButton>
                                                }

                                                {canCompleteTask.includes(task._id!) &&
                                                    <FilledButton
                                                        onClick={() => { onCompleteTask(task._id!) }}
                                                        theme='primary'
                                                        icon={<IoCheckmark />}
                                                        size='small'
                                                    >Complete Task
                                                    </FilledButton>}


                                                {canRequestRevision.includes(task._id!) &&
                                                    <OutlinedButton
                                                        onClick={() => { onRequestRevision(task._id!) }}
                                                        theme='primary'
                                                        icon={<IoBuildOutline />}
                                                        size='small'
                                                    >Revision
                                                    </OutlinedButton>}

                                                {canRequestCompletion.includes(task._id!) &&
                                                    <FilledButton
                                                        onClick={() => { onRequestCompletion(task._id!) }}
                                                        theme='primary'
                                                        icon={<IoCheckmark />}
                                                        size='small'
                                                    >Request Completion
                                                    </FilledButton>}

                                                {canAcceptDelivery.includes(task._id!) &&
                                                    <FilledButton
                                                        onClick={() => { onAcceptDelivery(task._id!) }}
                                                        theme='primary'
                                                        icon={<IoCheckmark />}
                                                        size='small'
                                                    >Accept Delivery
                                                    </FilledButton>}

                                                {canProvideDelivery.includes(task._id!) &&
                                                    <FilledButton
                                                        onClick={() => { onProvideDelivery(task._id!) }}
                                                        theme='primary'
                                                        icon={<IoCheckmark />}
                                                        size='small'
                                                    >Mark As Delivered
                                                    </FilledButton>}
                                            </div>
                                        </div>
                                        <div className="flex flex-col sm:mt-0 sm:flex-row sm:flex-wrap sm:space-x-6">
                                            {/* Info Icons */}
                                            {task.currentlyAssignedTo && <div className="mt-2 flex items-center text-sm text-gray-500 cursor-pointer">
                                                <img src={team.find(t => t._id === task.currentlyAssignedTo)?.profilePictureUrl || DEFAULT_USER_PROFILE.DEFAULT_FREELANCER_PROFILE_PICTURE_MALE} className='mr-1.5 size-5 shrink-0 rounded-full' />
                                                <span onClick={() => { goToUserProfile(EUserType.FREELANCER, task.currentlyAssignedTo!) }} className='cursor-pointer hover:underline'>{getFreelancerName(team.find(t => t._id === task.currentlyAssignedTo)!)}</span>
                                                <span>{canUnassignFreelancer.includes(task._id!) ?
                                                    <TextButton
                                                        size='xs'
                                                        theme='danger'
                                                        onClick={() => { onUnassignFreelancer(task._id!) }}
                                                    >Unassign</TextButton> : canUnassignMyself.includes(task._id!) ?
                                                        <TextButton
                                                            size='xs'
                                                            theme='danger'
                                                            onClick={() => { onUnassignMyself(task._id!) }}
                                                        >Step Out</TextButton> : ''}</span>
                                            </div>}
                                            {task.startDate && <div className="mt-2 flex items-center text-sm text-gray-500">
                                                <TbCalendarDue className='mr-1.5 size-5 shrink-0 text-gray-400' />
                                                <span>Start {dateToShortReadable(task.startDate)}</span>
                                            </div>}
                                            {task.dueDate && <div className="mt-2 flex items-center text-sm text-gray-500">
                                                <TbCalendarCheck className='mr-1.5 size-5 shrink-0 text-gray-400' />
                                                <span>Due {dateToShortReadable(task.dueDate)}</span>
                                            </div>}
                                            <div className="mt-2 flex items-center text-sm text-gray-500">
                                                <PiUserGear className='mr-1.5 size-5 shrink-0 text-gray-400' />
                                                <span>{task.actualCredits || task.estimatedCredits || 0} {isEmployer ? 'Hrs' : 'Credits'}</span>
                                            </div>
                                        </div>


                                        <div className='mt-4 ftext-gray-500 border border-dashed border-gray-300 rounded-xl bg-gray-50 px-4 py-2'><RichText text={task.briefDescription || ''} /></div>

                                        {(isPm || isEmployer || (isFreelancer && currentUser?._id === task.currentlyAssignedTo)) &&
                                            (task.revisions?.length || 0) > 0 &&
                                            <div className='mt-4 '>
                                                <p className='text-sm text-cyan-700'>Revision Requests</p>
                                                <div className='border border-dashed border-cyan-300 rounded-xl bg-cyan-50 px-4 py-2'>

                                                    {task.revisions?.map((revision, index) => (
                                                        <div key={revision.id}>
                                                            <span className='text-cyan-700 text-sm font-semibold'>[{revision.revisionBy.userType === EUserType.EMPLOYER ? 'Client' : 'PM'}] - </span>
                                                            <span className='text-cyan-700 text-sm font-semibold'>{dateToShortReadable(revision.revisionDate)}</span>
                                                            <span className='ml-4 text-cyan-700'>{revision.revisionMessage}</span>
                                                        </div>
                                                    ))}
                                                </div>
                                            </div>}

                                        <div className='mt-2 flex flex-row justify-end gap-3'>
                                            {showTaskDetails.includes(task._id!)
                                                ? <div className=' flex flex-row items-center justify-center gap-2 rounded-md w-full text-sm text-primary cursor-pointer hover:text-primary-700  hover:bg-primary-50 transition-all duration-300'
                                                    onClick={() => setShowTaskDetails(showTaskDetails.filter(id => id !== task._id!))}>
                                                    Hide Details
                                                    <IoChevronDown />
                                                </div>
                                                : <div className=' flex flex-row items-center justify-center gap-2 rounded-md w-full text-sm text-primary cursor-pointer hover:text-primary-700  hover:bg-primary-50 transition-all duration-300'
                                                    onClick={() => setShowTaskDetails([...showTaskDetails, task._id!])}>
                                                    Show Details
                                                    <IoChevronUp />
                                                </div>}
                                        </div>
                                    </div>
                                    {/* Task Details */}
                                    <div className={`transition-all duration-500 overflow-hidden ${showTaskDetails.includes(task._id!) ? '' : 'max-h-0'}`}>
                                        <dl className="divide-y divide-gray-100">
                                            {/* Description */}
                                            <div className="px-4 py-6 sm:grid sm:grid-cols-6 sm:gap-4 sm:px-0">
                                                <dt className="text-sm/6 font-medium text-gray-900">Description</dt>
                                                <dd className={`mt-1 flex text-sm/6 text-gray-700 sm:mt-0 ${canEdit ? 'sm:col-span-4' : 'sm:col-span-5'}`}>
                                                    <span className="grow">
                                                        {editDescription === task._id
                                                            ? <div className='flex flex-col gap-2'>
                                                                <RichTextEditor
                                                                    value={newDescription || ''}
                                                                    onChange={(value) => setNewDescription(value)}
                                                                />
                                                                {suggestedDescription && <AISuggestion
                                                                    onAccept={() => {
                                                                        setLastRequestedTaskDescriptionTimestamp(new Date().getTime());
                                                                        setNewDescription(suggestedDescription);
                                                                    }}
                                                                >
                                                                    <RichText text={suggestedDescription || ''} />
                                                                </AISuggestion>}
                                                            </div>
                                                            : <RichText text={task.description || ''} />}
                                                    </span>
                                                </dd>
                                                {canEdit && <span className="ml-4 shrink-0">
                                                    {editDescription
                                                        ? <div className='flex flex-row justify-end gap-3'>
                                                            {/* Save */}
                                                            <IconButton
                                                                icon={<IoMdCheckmark />}
                                                                onClick={onSaveDescription}
                                                                theme='primary'
                                                                isLoading={isSavingDescription}
                                                            />
                                                            {/* Cancel */}
                                                            <IconButton
                                                                icon={<IoMdClose />}
                                                                onClick={() => setEditDescription(null)}
                                                                theme='danger'

                                                            />

                                                        </div>
                                                        : <div className='flex flex-col items-end'>
                                                            {/* Edit */}
                                                            <IconButton
                                                                icon={<IoPencil />}
                                                                onClick={() => setEditDescription(task._id!)}
                                                                theme='primary'
                                                                disabled={project._roadmapVerifiedBy !== undefined && project._roadmapVerifiedBy !== null}
                                                            />
                                                        </div>}

                                                </span>}
                                            </div>


                                            {/* Definition of Done */}
                                            <div className="px-4 py-6 sm:grid sm:grid-cols-6 sm:gap-4 sm:px-0">
                                                <dt className="text-sm/6 font-medium text-gray-900">Definition of Done</dt>
                                                <dd className={`mt-1 flex text-sm/6 text-gray-700 sm:mt-0 ${canEdit ? 'sm:col-span-4' : 'sm:col-span-5'}`}>
                                                    <span className="grow">
                                                        {editDefinitionOfDone === task._id
                                                            ? <div className='flex flex-col gap-2'>
                                                                <RichTextEditor
                                                                    value={newDefinitionOfDone || ''}
                                                                    onChange={(value) => setNewDefinitionOfDone(value)}
                                                                />
                                                                {suggestedDefinitionOfDone && <AISuggestion
                                                                    onAccept={() => {
                                                                        setLastRequestedTaskDefinitionOfDoneTimestamp(new Date().getTime());
                                                                        setNewDefinitionOfDone(suggestedDefinitionOfDone);
                                                                    }}
                                                                >
                                                                    <RichText text={suggestedDefinitionOfDone || ''} />
                                                                </AISuggestion>}
                                                            </div>
                                                            : <RichText text={task.definitionOfDone || ''} />}
                                                    </span>
                                                </dd>
                                                {canEdit && <span className="ml-4 shrink-0">
                                                    {editDefinitionOfDone
                                                        ? <div className='flex flex-row justify-end gap-3'>
                                                            {/* Save */}
                                                            <IconButton
                                                                icon={<IoMdCheckmark />}
                                                                onClick={onSaveDefinitionOfDone}
                                                                theme='primary'
                                                                isLoading={isSavingDefinitionOfDone}
                                                            />
                                                            {/* Cancel */}
                                                            <IconButton
                                                                icon={<IoMdClose />}
                                                                onClick={() => setEditDefinitionOfDone(null)}
                                                                theme='danger'

                                                            />

                                                        </div>
                                                        : <div className='flex flex-col items-end'>
                                                            {/* Edit */}
                                                            <IconButton
                                                                icon={<IoPencil />}
                                                                onClick={() => setEditDefinitionOfDone(task._id!)}
                                                                theme='primary'
                                                                disabled={project._roadmapVerifiedBy !== undefined && project._roadmapVerifiedBy !== null}
                                                            />
                                                        </div>}

                                                </span>}
                                            </div>

                                            {/* Required Skills */}
                                            <div className="px-4 py-6 sm:grid sm:grid-cols-6 sm:gap-4 sm:px-0">
                                                <dt className="text-sm/6 font-medium text-gray-900">Skills</dt>
                                                <dd className={`mt-1 flex text-sm/6 text-gray-700 sm:mt-0 ${canEdit ? 'sm:col-span-4' : 'sm:col-span-5'}`}>
                                                    <span className="grow">
                                                        {editSkills === task._id
                                                            ? <MultiTextSelect
                                                                elements={newSkills || []}
                                                                setElements={setNewSkills}
                                                                placeholder="Skills"
                                                            />
                                                            : <div className='flex flex-wrap gap-2'>
                                                                {task.requiredSkills?.map((skill) => (
                                                                    <Chip key={skill}>
                                                                        {skill}
                                                                    </Chip>
                                                                ))}
                                                            </div>}
                                                    </span>
                                                </dd>
                                                {canEdit && <span className="ml-4 shrink-0">
                                                    {editSkills === task._id
                                                        ? <div className='flex flex-row justify-end gap-3'>
                                                            {/* Save */}
                                                            <IconButton
                                                                icon={<IoMdCheckmark />}
                                                                onClick={onSaveSkills}
                                                                theme='primary'
                                                                isLoading={isSavingSkills}
                                                            />
                                                            {/* Cancel */}
                                                            <IconButton
                                                                icon={<IoMdClose />}
                                                                onClick={() => setEditSkills(null)}
                                                                theme='danger'

                                                            />

                                                        </div>
                                                        : <div className='flex flex-col items-end'>
                                                            {/* Edit */}
                                                            <IconButton
                                                                icon={<IoPencil />}
                                                                onClick={() => setEditSkills(task._id!)}
                                                                theme='primary'
                                                                disabled={project._roadmapVerifiedBy !== undefined && project._roadmapVerifiedBy !== null}
                                                            />
                                                        </div>}

                                                </span>}
                                            </div>

                                            {/* Required Tools */}
                                            <div className="px-4 py-6 sm:grid sm:grid-cols-6 sm:gap-4 sm:px-0">
                                                <dt className="text-sm/6 font-medium text-gray-900">Required Tools</dt>
                                                <dd className={`mt-1 flex text-sm/6 text-gray-700 sm:mt-0 ${canEdit ? 'sm:col-span-4' : 'sm:col-span-5'}`}>
                                                    <span className="grow">
                                                        {editTools === task._id
                                                            ? <MultiTextSelect
                                                                elements={newTools || []}
                                                                setElements={setNewTools}
                                                                placeholder="Tools"
                                                                theme='secondary'
                                                            />
                                                            : <div className='flex flex-wrap gap-2'>
                                                                {task.requiredTools?.map((tool) => (
                                                                    <Chip key={tool} theme='secondary'>
                                                                        {tool}
                                                                    </Chip>
                                                                ))}
                                                            </div>}
                                                    </span>
                                                </dd>
                                                {canEdit && <span className="ml-4 shrink-0">
                                                    {editTools === task._id
                                                        ? <div className='flex flex-row justify-end gap-3'>
                                                            {/* Save */}
                                                            <IconButton
                                                                icon={<IoMdCheckmark />}
                                                                onClick={onSaveTools}
                                                                theme='primary'
                                                                isLoading={isSavingTools}
                                                            />
                                                            {/* Cancel */}
                                                            <IconButton
                                                                icon={<IoMdClose />}
                                                                onClick={() => setEditTools(null)}
                                                                theme='danger'

                                                            />

                                                        </div>
                                                        : <div className='flex flex-col items-end'>
                                                            {/* Edit */}
                                                            <IconButton
                                                                icon={<IoPencil />}
                                                                onClick={() => setEditTools(task._id!)}
                                                                theme='primary'
                                                                disabled={project._roadmapVerifiedBy !== undefined && project._roadmapVerifiedBy !== null}
                                                            />
                                                        </div>}

                                                </span>}
                                            </div>
                                        </dl>
                                    </div>

                                </div>

                                {/* Shortlisted Talent */}
                                {canShortlistTalent && <div
                                    className="mt-2 flex gap-1 text-xs hover:underline cursor-pointer text-gray-400"
                                    onClick={() => setShowShortlistedFreelancersLightbox(task._id!)}>
                                    <FiUserCheck />
                                    Shortlisted Talent ({task.freelancerShortlistByPm?.length || 0} | {task.freelancerShortlistByEmployer?.length || 0})
                                </div>}

                            </div>
                        ))}
                    </div>}

            </div>

            {showCreateNewRoadmapLightbox && <CreateNewRoadmapLightbox
                projectId={project._id!}
                onClose={() => setShowCreateNewRoadmapLightbox(false)}
                onReplaceTasks={setTasks}
            />}

            {showShortlistedFreelancersLightbox && <ShortlistedFreelancersLightbox
                task={orderedTasks.find(task => task._id === showShortlistedFreelancersLightbox)!}
                project={project}
                onClose={() => setShowShortlistedFreelancersLightbox(null)}
                onTaskUpdate={onUpdateTask}
            />}

            {showCreateNewTask && <CreateNewTaskLightbox
                projectId={project._id!}
                onClose={() => setShowCreateNewTask(false)}
                onAddTask={onAddTask}
                onUpdateProject={setProject}
            />}
            {showEditTaskHeader && <EditTaskHeaderLightbox
                projectId={project._id!}
                task={orderedTasks.find(task => task._id === editTaskHeader)!}
                onClose={() => setShowEditTaskHeader(false)}
                onUpdateTask={onUpdateTask}
                onUpdateProject={onUpdateProject}
            />}

            {showDeleteTaskLightbox && <ConfirmDeleteTaskLightbox
                task={orderedTasks.find(task => task._id === showDeleteTaskLightbox)!}
                onClose={() => setShowDeleteTaskLightbox(null)}
                replaceTasks={setTasks}
                onUpdateProject={onUpdateProject}
            />}

            {showPayAndStartLightbox && <StartAndPayTaskLightbox
                task={orderedTasks.find(task => task._id === showPayAndStartLightbox)!}
                onClose={() => setShowPayAndStartLightbox(null)}
                onUpdateTask={onUpdateTask}
            />}

            {showUnassignFreelancerLightbox && <UnassignFreelancerLightbox
                task={orderedTasks.find(task => task._id === showUnassignFreelancerLightbox)!}
                onClose={() => setShowUnassignFreelancerLightbox(null)}
                onUpdateTask={onUpdateTask}
            />}

            {showUnassignMyselfLightbox && <UnassignMyselfLightbox
                task={orderedTasks.find(task => task._id === showUnassignMyselfLightbox)!}
                onClose={() => setShowUnassignMyselfLightbox(null)}
                onUpdateTask={onUpdateTask}
            />}

            {showCompleteTaskLightbox && <CompleteTaskLightbox
                task={orderedTasks.find(task => task._id === showCompleteTaskLightbox)!}
                onClose={() => setShowCompleteTaskLightbox(null)}
                onUpdateTask={onUpdateTask}
                onUpdateProject={onUpdateProject}
            />}

            {showProvideDeliveryLightbox && <ProvideDeliveryLightbox
                task={orderedTasks.find(task => task._id === showProvideDeliveryLightbox)!}
                onClose={() => setShowProvideDeliveryLightbox(null)}
                onUpdateTask={onUpdateTask}
            />}

            {showAcceptDeliveryLightbox && <AcceptTaskDeliveryLightbox
                task={orderedTasks.find(task => task._id === showAcceptDeliveryLightbox)!}
                onClose={() => setShowAcceptDeliveryLightbox(null)}
                onUpdateTask={onUpdateTask}
                onUpdateProject={onUpdateProject}
            />}

            {showRequestRevisionLightbox && <RequestTaskRevisionLightbox
                task={orderedTasks.find(task => task._id === showRequestRevisionLightbox)!}
                onClose={() => setShowRequestRevisionLightbox(null)}
                onUpdateTask={onUpdateTask}
            />}

            {showRequestCompletionLightbox && <RequestTaskCompletion
                task={orderedTasks.find(task => task._id === showRequestCompletionLightbox)!}
                onClose={() => setShowRequestCompletionLightbox(null)}
                onUpdateTask={onUpdateTask}
            />}
        </div>

    )
}